<template>
  <div>
    <the-c-shop-content-first-no-shop
      v-if="noShop"
    />
    <the-c-shop-content-second />
    <the-create-shop-dialog />
  </div>
</template>

<script>
import TheCShopContentFirstNoShop from '../../layouts/Console/TheCShopContentFirstNoShop'
import TheCShopContentSecond from '../../layouts/Console/TheCShopContentSecond'
import TheCreateShopDialog from '../../layouts/Console/TheCreateShopDialog'

export default {
  name: 'ConsoleShop',
  components: {
    TheCShopContentFirstNoShop,
    TheCShopContentSecond,
    TheCreateShopDialog
  },
  computed: {
    noShop () {
      return true
    }
  }
}
</script>

<style>

</style>
